import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

@Component({
  selector: 'now-wbsuche-lib-feedback',
  templateUrl: './feedback.component.html',
  styleUrl: './feedback.component.scss',
  imports: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class FeedbackComponent {}
